<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" class="gray1--text">mdi-pencil-outline</v-icon>
    </template>
    <v-card class="pa-6">
      <v-card-text class="subtitle-1 mb-0 mt-1 text-center">Set Category Icon?</v-card-text>

      <v-card-text class="error--text font-weight-bold">
        <v-radio-group v-model="categoryIcon">
          <v-row justify="start">
            <v-col v-for="item in appIcons" :key="item._id" cols="3">
              <v-radio :value="item.icon"> </v-radio>
              <v-img :src="item.icon" max-width="30" height="30"> </v-img>
              {{ item.name }}
            </v-col>
          </v-row>
        </v-radio-group>
      </v-card-text>
      <v-card-actions justify="center">
        <v-row justify="center">
          <v-btn color=" mx-2 error" depressed @click="close">No</v-btn>
          <v-btn color=" mx-2 success" depressed :loading="button_loading" @click="onIconClick">Yes</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    appIcon: {
      required: false,
    },
    iconType: {
      type: String,
    },
  },
  apollo: {
    getAllAppIcons() {
      return {
        query: require("@/menu-packages/api/getAllAppIcons.graphql"),
        result({ data, loading }) {
          this.loading = loading;
          // let icons = []
          //  data.getAllAppIcons.map((icon)=>{
          //   if(icon.type === this.iconType){
          //     icons.push(icon)
          //   }
          // });
          //this.appIcons =  icons
          this.appIcons = data.getAllAppIcons;
          debugger;
        },
      };
    },
  },
  methods: {
    onIconClick() {
      debugger;
      //this.appIcon.icon = this.categoryIcon;      
      this.$emit("updateIcon",this.categoryIcon);
      this.dialog = false;
    },
    close() {
      this.dialog = false;
    },
  },
  data() {
    return {
      valid: true,
      dialog: false,
      button_loading: false,
      show_alert: false,
      categoryIcon: "",
      error: null,
      appIcons: [],
      alertData: {
        value: true,
        msg: "Member deleted !",
        msg_ar: "تم حذف العضو!",
        type: "success",
      },
    };
  },
};
</script>
